import $ from 'jquery';

export default class Tooltip {
  init(selector) {
    const elm = $(selector);
    elm.tooltip();
    elm.removeClass('nottooltipped');

    elm.on('shown.bs.tooltip', () => {
      setTimeout(() => {
        elm.tooltip('hide');
      }, 3000);
    });
    return elm;
  }
}
